module.exports = "<div\r\n      class=\"fileuploader\"\r\n      id=\"firmware-uploader\"\r\n    >\r\n    <p class=\"welcome_message\">Drag your files here or click here to browse files</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/front/upload/upload-file/upload-file.component.html
// module id = 586
// module chunks = 1